__turbopack_context__.v({
  "float": "wS1-Va_float",
  "header": "wS1-Va_header",
  "header_desktop": "wS1-Va_header_desktop",
  "header_mobile": "wS1-Va_header_mobile",
  "hide-mobile": "wS1-Va_hide-mobile",
  "hide-row": "wS1-Va_hide-row",
  "home": "wS1-Va_home",
  "iconButton": "wS1-Va_iconButton",
  "logo": "wS1-Va_logo",
  "slideInAnimation": "wS1-Va_slideInAnimation",
  "title": "wS1-Va_title",
});
